module.exports = __webpack_public_path__ + "static/Poyasnitelnaya_inf_k_otchetnosti_1_polugodie_2020-cf0e3abc14555f2d8fa3c95bc90cd043.pdf";